// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610080556/js/" + chunkId + "." + {"44":"be24be6a","225":"d978e899","481":"c48d2c81","486":"c06c5df7","770":"124a5189"}[chunkId] + ".0.7463386177053579.chunk.js";
};